<div *ngIf="!awaitingOTP" class="overflow-auto max-h-[80vh] p-0">
    <div class="border-b-2 pb-2 md:pb-5">
        <h1 mat-dialog-title class="text-2xl font-bold">View and accept your debit order</h1>
    </div>
    <mat-dialog-content class="flex flex-col h-full w-full overflow-hidden  ">
        <iframe [src]="iframeUrl" width="100%" height="500px"></iframe>
        <p class="text-base cursor-pointer my-4 lg:hidden">
            VIEW PDF
            <span class="font-bold" (click)="openInNewTab()">
                HERE
            </span>
        </p>
        <div class="lg:text-xl text-black text-base" *ngIf="mandateData?.Status.toLowerCase() !== 'accepted'">
            Once you have accepted, we will send a One Time Pin (OTP) to your mobile number {{data.customerNumber}} to
            confirm acceptance.
        </div>

    </mat-dialog-content>

    <mat-dialog-actions *ngIf="mandateData?.Status.toLowerCase() !== 'accepted'">
        <div class="flex flex-row w-full">
            <button class="flex m-2 p-4 w-full rounded-full border border-black text-black bg-gray-200" mat-flat-button
                (click)="actionDebitOrder('Reject')">I decline</button>
            <button class="m-2 p-4 w-full rounded-full" mat-flat-button [color]="'accent'"
                (click)="actionDebitOrder('Accept')">I accept</button>
        </div>
    </mat-dialog-actions>

    <mat-dialog-actions *ngIf="mandateData?.Status.toLowerCase() === 'accepted'">
        <div class="flex flex-row w-full">
            <button class="flex m-2 p-4 w-full rounded-full border border-black text-black bg-gray-200" mat-flat-button (click)="closeDialog()">
                Close
            </button>
        </div>
    </mat-dialog-actions>
</div>

<div *ngIf="awaitingOTP" class="max-h-[80vh] overflow-auto">

    <div class="border-b-2 pb-2 md:pb-5">
        <h1 mat-dialog-title class="text-2xl font-bold">Please input your OTP</h1>
    </div>
    <p  mat-dialog-title class="text-base font-bold lg:text-2xl">
        OTP has been sent to your email and/or mobile phone.
    </p>
    <div class="flex flex-col items-center w-full justify-center mt-12">
        <ng-otp-input #otpValue (onInputChange)="onOtpChange($event)" [config]="{length:6, allowNumbersOnly: true}"></ng-otp-input>
    </div>
    <mat-dialog-actions>
        <div class="flex lg:flex-row mt-8 w-full flex-col">
            <button class="m-2 p-4 w-full rounded-full bg-gray-200" mat-flat-button
                (click)="closeDialog()">Close</button>
            <button *ngIf="otpTimer != 0" class="m-2 p-4 w-full rounded-full" mat-flat-button [color]="'primary'"
                disabled>{{otpTimer}}</button>
            <button *ngIf="otpTimer == 0" class="m-2 p-4 w-full rounded-full" mat-flat-button [color]="'primary'"
                (click)="actionDebitOrder('Resend')">Resend OTP</button>
            <button class="m-2 p-4 w-full rounded-full" mat-flat-button [color]="'accent'" [disabled]="!otp"
                (click)="authoriseMandate(otpValue)">Submit</button>
        </div>
    </mat-dialog-actions>
</div>